import { LoadingDetails, LoadState } from '@nx-ng/types';

export const getLoadingDetails = (
  loadState: LoadState,
  loadText: string,
  isUpdating?: boolean
): LoadingDetails => {
  const loadingDetails: LoadingDetails = {
    isLoading: false,
    text: loadText,
  };

  if (loadState !== LoadState.LOADING) return loadingDetails;

  if (isUpdating) {
    loadingDetails.isUpdating = true;
    return loadingDetails;
  }

  loadingDetails.isLoading = true;
  return loadingDetails;
};
